import css from 'src/components/empty-placeholder/empty-placeholder.module.scss';

export default function EmptyPlaceholder() {
  return (
    <div className={css.placeholder}>
      <span className={css.title}>За Вашим запитом поки немає послуг</span>
      <span className={css.recommendation}>Скористайтесь простими рекомендаціями:</span>
      <ul>
        <li>Перевірте правильність написання запиту</li>
        <li>Спробуйте використати більш загальний запит</li>
        <li>Спробуйте знайти іншу послугу</li>
      </ul>
    </div>
  );
}
